import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { MailWarning, MailX } from "lucide-react";
import { api } from "@/lib/api";

export function EmailHealthBanner({ role }) {
  const { data } = useQuery({ queryKey: ["email-health"], queryFn: () => api.get("/delivery/email-health").then((r) => r.data), refetchInterval: 60000, enabled: role === "admin" });
  if (!data || data.state === "ok") return null;
  const blocked = data.state === "blocked";
  return (
    <div role="alert" data-testid={`email-health-banner-${data.state}`}
      className={blocked ? "border-b border-rose-800 bg-rose-700 text-white" : "border-b border-amber-300 bg-amber-50 text-amber-900"}>
      <div className="mx-auto flex max-w-[1600px] flex-wrap items-center gap-x-4 gap-y-1 px-4 py-2.5 text-sm sm:px-6 lg:px-8">
        {blocked ? <MailX className="h-5 w-5 shrink-0" /> : <MailWarning className="h-5 w-5 shrink-0" />}
        <span className="font-bold">{blocked ? "Email delivery is blocked — alerts and digests are NOT reaching people." : "Some emails are failing and retrying."}</span>
        <span className={blocked ? "text-rose-50" : ""} data-testid="email-health-banner-headline">{data.headline}.</span>
        <Link to="/delivery" className={`ml-auto rounded-md px-3 py-1 text-xs font-semibold ${blocked ? "bg-white text-rose-700 hover:bg-rose-50" : "bg-amber-900 text-white hover:bg-amber-800"}`} data-testid="email-health-banner-link">Fix it in Delivery Monitor →</Link>
      </div>
    </div>
  );
}
